import React from 'react';
import styles from './styles.module.scss';

const SaveButton = ({ onHandleSaveClick }) => (
  <input type='button' onClick={onHandleSaveClick} className={styles.saveButton} value='Save' />
)

export default SaveButton; 